import { ImageQuality } from "@pcp/core/interfaces";
import { IDisplaySlide, IDynamicContentSlide } from "@pcp/core/interfaces";
import { swapImageQualityInUrl } from "../util/swap-image-quality-in-url";

/** IDisplaySlide with reduced information for minimized Payload */
export type ITransferDisplaySlide = Omit<IDisplaySlide, 'imageVariants' | 'previewpicture'>;
export type ITransferDynamicContentSlide = Omit<IDynamicContentSlide, 'imageVariants'>;

export const transformDisplaySlideToTransformSlide = (displaySlide: IDisplaySlide): ITransferDisplaySlide => {
    const { imageVariants, previewpicture, ...transferSlide } = displaySlide;

    return transferSlide;
};

export const transformDynamicContentSlideSlideToTransformSlide = (displaySlide: IDynamicContentSlide): ITransferDynamicContentSlide => {
    const { imageVariants, ...transferSlide } = displaySlide;

    return transferSlide;
};

export const transformTransferSlideToDynamicContentSlide =
    (transferSlide: ITransferDynamicContentSlide, preferredImageQuality: ImageQuality): IDynamicContentSlide => {
        if ('imageResource' in transferSlide) {
            return ({
                ...transferSlide,
                imageResource: swapImageQualityInUrl(transferSlide.imageResource, preferredImageQuality),
                imageVariants: {
                    [ImageQuality.LOW]: swapImageQualityInUrl(transferSlide.imageResource, ImageQuality.LOW),
                    [ImageQuality.MEDIUM]: swapImageQualityInUrl(transferSlide.imageResource, ImageQuality.MEDIUM),
                    [ImageQuality.HIGH]: swapImageQualityInUrl(transferSlide.imageResource, ImageQuality.HIGH),
                },
            });
        } else {
            return transferSlide as IDynamicContentSlide;
        }
    };
